export class MFAValidateCodeModel {
    code: string | null = null;
    mfaValidationKey: string | null = null;
    userId: string | null = null;
}
